import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { BaseComponent } from '../../../shared/utils/base.component';
import { SectionsService } from '../../../services/sections.service';
import { STATIC_JSON_DATA_PATH } from '../../../shared/constants/static-data.constants';
import { LoggerService } from '../../../shared/services/logger.service';
import { ListTableComponent } from '@ppl/ui';
import { TableRowActions } from '../../../shared/interfaces/actions';
import { TableRowActionsModel } from '../../../shared/interfaces/list.interface';
import { AuthorizationUtility } from '../../../shared/authorization/auth.utility';
import { LeadDetailsService } from '../../../services/lead-details.service';
import {
  DialogConfig,
  DialogService,
} from '../../../shared/services/dialog.service';

@Component({
  selector: 'ppl-login-details',
  standalone: true,
  imports: [ListTableComponent],
  templateUrl: './login-details.component.html',
  styleUrl: './login-details.component.css',
})
export class LoginDetailsComponent extends BaseComponent implements OnInit {
  @Input() pageId = '';
  @Input() tabId = '';
  @Input() program: any;
  @Input() readOnly = false;
  @Input() selectedLeadId: any;
  @Input() entry: any;
  @Output() leadUpdated = new EventEmitter<boolean>();
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;

  cols: any;
  loginData = [];
  isSectionEditable = true;
  isSectionDeletable = false;
  private dialogSvc = inject(DialogService);
  actionButtons: TableRowActionsModel = new TableRowActions();

  constructor(
    private sectionService: SectionsService,
    private logger: LoggerService,
    private authUtility: AuthorizationUtility,
    private leadDetailsService: LeadDetailsService
  ) {
    super();
  }

  ngOnInit(): void {
    this.isSectionEditable = this.readOnly
      ? false
      : this.authUtility.isSectionEditable(
          this.pageId,
          this.tabId,
          'Usernames'
        );
    this.isSectionDeletable = this.readOnly
      ? false
      : this.authUtility.isSectionDeletable(
          this.pageId,
          this.tabId,
          'Usernames'
        );
    // Delete visibility is driven per-row (see formatResponse) so inactive roles
    // (userRoleActive === 'No') don't get a delete action. The list table shows the
    // button when actionButtons.delete OR rowData.actions.delete is true, so we must
    // NOT enable it globally here - that would override the per-row flag for every row.
    this.getColumns();
    this.getLoginData();
  }

  async getColumns() {
    try {
      if (this.entry) {
        const tempCols = await this.sectionService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.LEAD_DETAILS_CONTACT_LIST_HEADERS,
          this.entry
        );
        this.cols = tempCols.loginDetails.columns;
      }
    } catch (e) {
      this.logger.debug('Error in getting column data', e);
    }
  }

  formatResponse(data: any[]) {
    if (data) {
      const copyData = JSON.parse(JSON.stringify(data));
      copyData.forEach((data: any) => {
        const isActive = data.userRoleActive?.toLowerCase() === 'yes';
        data.actions = {
          delete: isActive && this.isSectionDeletable,
        };
      });
      this.loginData = copyData;
    }
  }

  getLoginData() {
    const payload = {
      programCode: this.program.program_code,
      participantId:
        this.entry === 'participantEnrollment' ? this.selectedLeadId : null,
      providerId:
        this.entry === 'providerEnrollment' ? this.selectedLeadId : null,
    };
    this.leadDetailsService.getLoginDetails(payload).subscribe((data: any) => {
      this.formatResponse(data.responsedata);
    });
  }

  deleteUserRole(userData: any) {
    const payload = {
      azureUUID: userData.azureUUID
    }
    this.leadDetailsService
      .deleteAuthUserRole(this.program.program_code, userData.userRoleId, payload)
      .subscribe((data: any) => {
        if (data.status === 200) {
          this.getLoginData();
        }
      });
  }

  action(event: any) {
    if (event.action === 'delete') {
      this.openConfirmationPopup(event.data);
    }
  }

  handleCancel() {}

  openConfirmationPopup(id: any) {
    const dialogConfig: DialogConfig = {
      title: 'Confirmation',
      okText: 'Ok',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.confirmationDialog,
      dialogConfig,
      () => this.deleteUserRole(id),
      () => this.handleCancel()
    );
  }
}
